'use strict';
const angular = require('angular');

/*@ngInject*/
export function ClosingSnapshotsService($resource) {
  return $resource('/api/closing-snapshots/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    getIds: {
      method: 'GET',
      url: '/api/closing-snapshots/ids/active',
      isArray: true
    }
  });
}


export default angular.module('conduu.ClosingSnapshotsService', [])
  .factory('ClosingSnapshotsService', ClosingSnapshotsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/closing-snapshots/closing-snapshots.service.js